import { BREAKPOINT_MOBILE } from "../../../../constants/constants";
import {
  useGetPageFromPath,
  useIsSerialProcess,
} from "../../../../utils/customHooks/genericHooks";

import { TILES_CARD } from "pages/useTileSize";
import { css } from "styled-components/macro";
import ErrorBoundary from "components/SimpleComponents/Errors/ErrorBoundary";
import SerialProcessInfo from "../SerialProcessInfo";
import ViewTimelineTabs from "components/Dashboard/ViewTimelineTabs";
import ServiceOutageIndicator from "components/SimpleComponents/TopBanner/ServiceOutageIndicator";
import TimelinePageSection from "../DashboardPagesSections/TimelinePageSection/TimelinePageSection";
import ProcessTilesControls from "../../ProcessTilesControls/ProcessTilesControls";
import ProcessTilesPanel from "components/Dashboard/Tiles/ProcessTile/ProcessTilesPanel";
import GroupTilesPanel from "../../../../components/Dashboard/Tiles/GroupTile/GroupTilesPanel";
import { RangeSelectorCard } from "../DashboardPagesSections/RangeSelectorCard";
import { GroupSummaryCard } from "../DashboardPagesSections/GroupSummaryCard";
import { GroupTilesPanelCard } from "../DashboardPagesSections/GroupTilesPanelCard";

export function TilesTimelinePages() {
  const isSerialProcess = useIsSerialProcess();

  const {
    isGroupTilesPage,
    isTimelinePage,
    isHubletPage,
    isProcessTilesPage,
    isAllWorkSchedulesPage,
  } = useGetPageFromPath();

  const shouldShowSerialProcessIndicator =
    isSerialProcess && !isHubletPage && !isGroupTilesPage;
  const showTilesTimelineTabs = !isGroupTilesPage;

  return (
    <>
      <ServiceOutageIndicator
        customCss={css`
          margin: 5px 5px 0;
          @media (min-width: ${BREAKPOINT_MOBILE}px) {
            margin: 10px 10px;
          }
          position: fixed;
          z-index: 1000;
          bottom: 8px;
          opacity: 0.9;
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
          left: 0;
          right: 0;
        `}
      />
      {/* TODO: better implementation of connectivity detection - see PRO-644 https://raventelemetry.atlassian.net/browse/PRO-644 */}
      {/* <IsWifiConnectedIndicator /> */}
      {shouldShowSerialProcessIndicator && <SerialProcessInfo />}
      {showTilesTimelineTabs && <ViewTimelineTabs />}
      <div className="belowTabsContent" style={{ position: "relative" }}>
        {isTimelinePage ? <RangeSelectorCard /> : null}
        {!window.location.search.includes("hideSummary=true") &&
          !(isAllWorkSchedulesPage && isGroupTilesPage) && <GroupSummaryCard />}
        <div className="belowDividerContent">
          {isTimelinePage ? (
            <ErrorBoundary id="TimelinePageSection">
              <TimelinePageSection />
            </ErrorBoundary>
          ) : isGroupTilesPage && isAllWorkSchedulesPage ? (
            <ErrorBoundary small={true} id="GroupTilesPanel">
              <GroupTilesPanelCard />
            </ErrorBoundary>
          ) : isGroupTilesPage ? (
            <div className={`cardItem ${TILES_CARD}`}>
              <ErrorBoundary small={true} id="GroupTilesPanel">
                <GroupTilesPanel />
              </ErrorBoundary>
            </div>
          ) : (
            <div className={`cardItem ${TILES_CARD}`}>
              {isProcessTilesPage && (
                <ErrorBoundary small={true} id="ProcessTilesControls">
                  <ProcessTilesControls />
                </ErrorBoundary>
              )}
              <ErrorBoundary small={true} id="ProcessTilesPanel">
                <ProcessTilesPanel />
              </ErrorBoundary>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
